(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.PocketGallery=factory();
})(typeof window!=='undefined'?window:this,function(){
  'use strict';
  // Each gallery's API by its element, so the card viewer's Front / Back (assets/pf-view.js, P1-VIEW-1) turn it through
  // its own views: of(gallery).view('back').
  const instances=new WeakMap();
  function of(gallery){return gallery&&instances.get(gallery)||null;}
  function init(scope){
    const gallery=scope.querySelector('[data-gallery]');
    if(!gallery||gallery.dataset.galleryReady)return null;
    const scene=gallery.querySelector('[data-gallery-main]');
    const buttons=[...gallery.querySelectorAll('[data-gallery-view],[data-gallery-photo-view]')];
    const strip=gallery.querySelector('.pf-detail-strip');
    if(!scene||!buttons.length)return null;
    gallery.dataset.galleryReady='true';
    // I8: a variant's own photo (snippets/pocket-gallery.liquid) is a view too, in the live card's place. The card stays
    // drawn under it, unseen, and the live view last chosen comes back when the photo goes.
    const view=gallery.querySelector('[data-card-main]'),photos=[...gallery.querySelectorAll('[data-gallery-photo]')];
    let live=buttons.find(b=>b.dataset.galleryView&&b.getAttribute('aria-pressed')==='true')||buttons.find(b=>b.dataset.galleryView);
    function show(button,focus=false){
      if(!button)return;
      const photo=button.dataset.galleryPhotoView||'';
      if(!photo){scene.dataset.scene=button.dataset.galleryView;live=button;}
      if(photos.length){
        photos.forEach(p=>p.hidden=p.dataset.galleryPhoto!==photo);
        view?.toggleAttribute('data-gallery-photo-shown',!!photo);
        const alt=photos.find(p=>p.dataset.galleryPhoto===photo)?.querySelector('img')?.alt;
        view?.setAttribute('aria-label',photo?alt||button.getAttribute('aria-label'):view.dataset.galleryLabel||view.getAttribute('aria-label'));
      }
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      if(focus)button.focus({preventScroll:true});
      const left=button.offsetLeft,right=left+button.offsetWidth;
      if(left<strip.scrollLeft||right>strip.scrollLeft+strip.clientWidth)
        strip.scrollTo?.({left:Math.max(0,left-(strip.clientWidth-button.offsetWidth)/2),behavior:'auto'});
    }
    // The views on offer: a photo's button is there only while its variant is chosen.
    const offered=()=>buttons.filter(b=>!b.hidden);
    function select(index,focus=false){
      const list=offered();
      show(list[(index+list.length)%list.length],focus);
    }
    buttons.forEach(button=>{
      button.addEventListener('click',()=>show(button));
      button.addEventListener('keydown',event=>{
        const list=offered(),index=list.indexOf(button);
        const next={ArrowRight:index+1,ArrowLeft:index-1,Home:0,End:list.length-1}[event.key];
        if(next===undefined)return;
        event.preventDefault();select(next,true);
      });
    });
    // A named live view (the viewer's Front / Back: "front", "back"), as its button in the strip shows it, a photo going.
    function showView(name){show(buttons.find(b=>b.dataset.galleryView===name));}
    const api={select,view:showView,scene:()=>scene.dataset.scene||''};
    instances.set(gallery,api);
    if(!photos.length)return api;
    // A variant's photo is the one that lists it (data-gallery-photo-variants, ",id,id,").
    const photoOf=id=>photos.find(p=>!!id&&(p.dataset.galleryPhotoVariants||'').includes(','+id+','))?.dataset.galleryPhoto||'';
    const shownPhoto=()=>buttons.find(b=>b.getAttribute('aria-pressed')==='true')?.dataset.galleryPhotoView||'';
    const offer=photo=>buttons.forEach(b=>{if(b.dataset.galleryPhotoView)b.hidden=b.dataset.galleryPhotoView!==photo;});
    // Each change of variant: its photo's button shows and the others go. Its photo shows when it isn't the last variant's
    // (a card color picked); a photo it hasn't gives way to the live view; anything else (no photo, or the same one:
    // another pack) stays as the shopper left it.
    function changed(variant,previous){
      const next=photoOf(variant),before=photoOf(previous),shown=shownPhoto();
      offer(next);
      if(next&&next!==before)show(buttons.find(b=>b.dataset.galleryPhotoView===next));
      else if(shown&&shown!==next)show(live);
    }
    // This line's pocket.js says the chosen variant only by writing it in the form's id field (refresh(),
    // [data-variant-id]): beta's pocket:variant isn't here. So the gallery hears that field. Each write, once pocket.js's
    // refresh is over, is a change when its variant isn't the last one heard. The page opens on the variant the field
    // holds now: its photo's button, and no photo of another variant.
    const field=scope.querySelector('form [data-variant-id]');
    if(field){
      let heard=String(field.value||'');
      const start=photoOf(heard);offer(start);
      if(shownPhoto()&&shownPhoto()!==start)show(live);
      const own=Object.getOwnPropertyDescriptor(Object.getPrototypeOf(field),'value');
      if(own?.get&&own.set){
        let due=false;
        const hear=()=>{due=false;const now=String(own.get.call(field)||'');if(now===heard)return;const was=heard;heard=now;changed(now,was);};
        Object.defineProperty(field,'value',{configurable:true,enumerable:own.enumerable,get(){return own.get.call(this);},set(value){own.set.call(this,value);if(!due){due=true;Promise.resolve().then(hear);}}});
      }
    }
    // Anything else they choose in the form is drawn on the card (its design, their business, the finish): the live view
    // comes back where a photo was, so each choice shows on it (on short phones the open "Personalize design" panel pins
    // the card alone, with no strip). This runs before pocket.js hears the choice (capture), so a variant that gets
    // another photo from it still shows that one. The edge color and the pack are the variant's own.
    const OWN='[data-pf-cc-value],[data-pack],[data-pfx-pack]';
    for(const type of ['input','change'])scope.addEventListener(type,event=>{
      const target=event.target;
      if(!(event.isTrusted||event.pfChosen)||!target?.closest?.('form')||target.matches(OWN))return;
      if(shownPhoto())show(live);
    },true);
    // So does a card that becomes theirs another way: changed on a call or in the chat (pocket:remote-applied), opened
    // from a saved card (pocket:card-profile-applied), or their business coming in (the brand store: beta hears this as
    // pf:design-ready, which this line doesn't have).
    const doc=scope.ownerDocument,back=()=>{if(scope.isConnected&&shownPhoto())show(live);};
    for(const type of ['pocket:remote-applied','pocket:card-profile-applied'])doc.addEventListener(type,back);
    const store=doc.defaultView?.PocketPersonalization?.store;
    if(typeof store?.subscribe==='function'){
      let brand=store.getState?.()?.brand||null;
      store.subscribe(()=>{const now=store.getState?.()?.brand||null;if(now===brand)return;brand=now;if(now)back();});
    }
    return api;
  }
  return {init,of};
});
